import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { PasswordResetToken } from '../../core/model/password-reset-token';
import { PasswordResetService } from '../../core/services/password-reset.service';



@Component({
  selector: 'app-nueva-password',
  templateUrl: 'nueva-password.component.html',
  styleUrls: ['nueva-password.component.css']
})

export class NuevaPasswordComponent implements OnInit, OnDestroy {
  error: string;
  password: string;
  repeatedPassword: string;
  passwordResetToken: PasswordResetToken;
  passwordError = false;
  existValidateToken = false;
  failValidateToken = false;
  constructor(
    private passwordResetService: PasswordResetService,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private router: Router
  ) {
  }

  ngOnInit() {

    this.passwordResetService.validatePasswordResetToken(this.passwordResetService.getToken()).subscribe(
      result => {
        if (result !== null) {
          this.passwordResetService.updateToken(result);
          this.passwordResetToken = this.passwordResetService.getToken();
          this.existValidateToken = true;
          this.failValidateToken = false;

        } else {
          this.passwordResetService.resetToken();
          this.existValidateToken = false;
          this.failValidateToken = true;
        }
      },
      error => {
        // console.log(error);
        this.passwordResetService.resetToken();
        this.existValidateToken = false;
        this.failValidateToken = true;
      }
    );
  }

  canSend(): boolean {
    return this.password !== undefined && this.password.trim() !== '' && this.repeatedPassword !== undefined;
  }

  validateFields(): boolean {
    if (this.password !== this.repeatedPassword) {
      this.error = 'Las contraseñas introducidas no coinciden.';
      this.passwordError = true;
      return false;
    }
    if (this.password.length < 8) {
      this.error = 'La contraseña debe tener una longitud mínima de 8 caracteres.';
      this.passwordError = true;
      return false;
    }

    let mayusculas = false;
    let minusculas = false;
    let numeros = false;
    for (let x = 0; x < this.password.length; x++) {
      const char = this.password.charAt(x);
      if (char >= 'a' && char <= 'z') {
        minusculas = true;
      }
      if (char >= 'A' && char <= 'Z') {
        mayusculas = true;
      }
      if (char >= '0' && char <= '9') {
        numeros = true;
      }
    }
    if (!minusculas || !mayusculas || !numeros) {
      this.error = 'La contraseña debe estar compuesta de caracteres alfanuméricos en mayúsculas y minúsculas';
      this.passwordError = true;
      return false;
    }
    this.error = undefined;
    return true;
  }

  executePasswordReset() {
    if (this.validateFields()) {
      this.passwordError = false;
      this.passwordResetToken.password = this.password;
      this.passwordResetService.executePasswordReset(this.passwordResetToken).subscribe(result => {
        if (typeof result === 'number') {
          this.successMessage();
          this.router.navigate(['/login']);
        } else {
          this.errorCode();
          this.router.navigate(['/']);
        }
      },
        error => {
          this.errorCode();
          this.router.navigate(['/']);
        }
      );
      this.passwordResetService.resetToken();
    }
  }
  ngOnDestroy() {
    this.passwordResetService.resetToken();
  }

  errorCode() {
    this.translateService.get(['mensajes'])
      .subscribe(values => {
        this.toastr.warning(values['mensajes']['passworderror'],
          values['mensajes']['nodatatitle']);
      });
  }

  successMessage() {
    this.translateService.get(['mensajes'])
      .subscribe(values => {
        this.toastr.success(values['mensajes']['passwordsuccess'],
          values['mensajes']['passwordupdate']);
      });
  }
}
